<template>
  <NumeraiModal
    ref="modal"
    :dialog="dialog"
    :button="button"
    title="New Model"
    :button-text="buttonText"
    :fields="fields"
    disabled-tooltip="loading..."
    :enabled-tooltip="enabledTooltipText"
    :fill="fill"
    :full-width="full"
    save-button-text="Create Model"
    :loading="fetching"
    :save-callback="save"
    @close="close"
  >
    <template v-slot:activator>
      <slot></slot>
    </template>
    <div class="pb-3">
      <p>
        Create more models, each with its own submissions, scores and stakes, to
        experiment with different approaches.
        <strong>
          Your account may have up to {{ modelsRemaining }} more models, but you
          can increase this limit by performing well and earning a higher
          Grandmaster Tier this season.
        </strong>
      </p>
      <p></p>
    </div>
    <input
      v-model="fields.name"
      class="numerai-input full-width"
      placeholder="Model name"
      :disabled="fetching"
    />
    <span class="color-error">{{ msg }}</span>
  </NumeraiModal>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import NumeraiModal from '@/components/shared/NumeraiModal'
import { getTournamentNumber } from '@/lib/utils'

const defaultFields = {
  name: '',
}
export default {
  components: {
    NumeraiModal,
  },
  props: {
    fill: { type: Boolean, default: false },
    full: { type: Boolean, default: false },
    dialog: { type: Boolean, default: false },
    button: { type: Boolean, default: true },
    onClose: { type: Function, default: null },
    onCreate: { type: Function, default: null },
    buttonText: { type: String, default: 'Add New Modal' },
  },
  data() {
    return {
      fields: {
        ...defaultFields,
      },
      msg: '',
      fetching: false,
    }
  },
  computed: {
    ...mapState(['modelsLimit']),
    ...mapGetters(['atModelLimit', 'modelsRemaining']),
    enabledTooltipText() {
      return 'You can add ' + this.modelsRemaining + ' more models'
    },
  },
  methods: {
    ...mapActions(['showSnackBar', 'fetchAccountInfo']),
    close() {
      this.fields = {
        ...defaultFields,
      }
      this.onClose && this.onClose()
    },
    async save() {
      this.fetching = true
      try {
        this.msg = ''
        const response = await this.$client.addModel(
          this.fields.name,
          getTournamentNumber(),
        )
        const id = response.addModel.id
        const name = response.addModel.name

        await this.fetchAccountInfo()
        await this.$store.dispatch('fetchV3UserProfile', {
          username: name,
          tournament: getTournamentNumber(),
        })
        this.fields = {
          ...defaultFields,
        }
        this.onCreate && this.onCreate()
        this.$refs.modal.close()
        this.showSnackBar({
          msg: `Created model ${name} with ID ${id}`,
          time: 3,
        })
      } catch (e) {
        this.msg = e.message
      }
      this.fetching = false
    },
  },
}
</script>
